var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page_"},[_c('navbar',{attrs:{"flag":0}}),_c('div',{staticClass:"con_"},[_c('img',{attrs:{"src":_vm.introduceUrl,"alt":""}})]),_c('footbar')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }